// extracted by mini-css-extract-plugin
export default {"pagination":"T1uRnC","disabled":"DlaboL"};